var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Treeselect,_vm._b({class:'custom-nace-select',attrs:{"normalizer":_setup.normalizerNace,"options":_setup.naceOptionTree,"disable-fuzzy-matching":"","value":_setup.patchedValue,"loading":_setup.loading},on:{"input":_setup.onInput}},'treeselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }